import { startOfYear, endOfYear, format } from 'date-fns';
import drivingPermitStatisticsService from '@/api/driving-permit-statistics-service';

export const getDefaultDrivingPermitStatisticsFilterParams = () => ({
  date_from: format(startOfYear(new Date()), 'yyyy-MM-dd'),
  date_to: format(endOfYear(new Date()), 'yyyy-MM-dd'),
  group_by: 'airport', // 'airport' or 'manoeuvre_type'
});

const state = {
  drivingPermitStatistics: null,
  drivingPermitStatisticsChartData: null,
  drivingPermitStatisticsFilterParams: getDefaultDrivingPermitStatisticsFilterParams(),
  drivingPermitStatisticsDisplayMode: 'text', // 'text' or 'chart'
};

const getters = {};

const mutations = {
  SET_DRIVING_PERMIT_STATISTICS(state, statistics) {
    state.drivingPermitStatistics = statistics;
  },

  SET_DRIVING_PERMIT_STATISTICS_CHART_DATA(state, statistics) {
    state.drivingPermitStatisticsChartData = statistics;
  },

  SET_DRIVING_PERMIT_STATISTICS_FILTER_PARAMS(state, params) {
    state.drivingPermitStatisticsFilterParams = params;
  },

  SET_DRIVING_PERMIT_STATISTICS_DISPLAY_MODE(state, mode) {
    state.drivingPermitStatisticsDisplayMode = mode;
  },
};

const actions = {
  fetchDrivingPermitStatistics({ commit }, params = {}) {
    commit('SET_DRIVING_PERMIT_STATISTICS_FILTER_PARAMS', params);
    return drivingPermitStatisticsService.getDrivingPermitStatistics(params).then((res) => {
      res.data.forEach((item) => {
        item.airports.forEach((airport) => {
          airport.manoeuvre_type.sort((a, b) => {
            return b.has_requested_ability_to_manoeuvre - a.has_requested_ability_to_manoeuvre;
          });
        });
      });

      commit('SET_DRIVING_PERMIT_STATISTICS', res.data);
    });
  },

  fetchDrivingPermitStatisticsChartData({ commit }, params = {}) {
    commit('SET_DRIVING_PERMIT_STATISTICS_FILTER_PARAMS', params);
    return drivingPermitStatisticsService
      .getDrivingPermitStatisticsChartData(params)
      .then((res) => {
        commit('SET_DRIVING_PERMIT_STATISTICS_CHART_DATA', res.data);
      });
  },

  setDrivingPermitStatisticsDisplayMode({ commit }, mode) {
    commit('SET_DRIVING_PERMIT_STATISTICS_DISPLAY_MODE', mode);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
